import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { collection, doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { Snackbar } from '@mui/material';

const AddGuestForm = ({ mode }) => {
  const { documentId } = useParams();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const navigate = useNavigate();
  const [guestData, setGuestData] = useState({
    name: '',
    email: '',
    phoneNumber: ''
  });

  useEffect(() => {
    if (mode === 'edit') {
      const loadGuestData = async () => {
        // const app = initializeApp(firebaseConfig);
        // const db = getFirestore(app);

        const docRef = doc(db, 'guest', documentId);
        const docSnapshot = await getDoc(docRef);

        if (docSnapshot.exists()) {
          const guestData = docSnapshot.data();
          setGuestData(guestData);
        } else {
          //console.log('Guest not found!');
        }
      };
      loadGuestData();
    }
  }, [mode, documentId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setGuestData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (mode === 'edit') {
        const docRef = doc(db, 'guest', documentId);
        await updateDoc(docRef, guestData);
        //console.log('Guest data updated successfully!');
        setOpenSnackbar(true);
        navigate("/admin-panel")
      } else {
        const newDocRef = doc(collection(db, 'guest'));
        await setDoc(newDocRef, guestData);
        //console.log('New guest data added successfully!');
        navigate("/admin-panel")
      }
    } catch (error) {
      console.error('Error saving guest data: ', error);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <div>
      <h1>{mode === 'edit' ? 'Edit Guest' : 'Add Guest'}</h1>
      <form onSubmit={handleSubmit}>
        <label htmlFor="name">Name:</label>
        <input
          type="text"
          id="name"
          name="name"
          value={guestData.name}
          onChange={handleInputChange}
          required
        />
        <br />
        {mode !== "aedit" && <>
          <label htmlFor="email">Email:</label><br />
          <input
            type="email"
            id="email"
            name="email"
            value={guestData.email}
            onChange={handleInputChange}
          />
          <br />
          <label htmlFor="phoneNumber">Phone Number:</label><br />
          <input
            type="tel"
            id="phoneNumber"
            name="phoneNumber"
            value={guestData.phoneNumber}
            onChange={handleInputChange}
          />
        </>}
        <br />
        <button type="submit">{mode === 'edit' ? 'Save' : 'Add'}</button>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          message="Participant saved successfully!"
        />
      </form>
    </div>
  );
};

export default AddGuestForm;
